import { Alert, Box, Button } from "@mui/material";
import { useStateValue } from "../../context/StateValueContext";
import { useFetchCompanySettings } from "../../hooks/useCompanySettings";

// Shown where a page can't be resolved because /api/client-settings failed: we
// don't know whether the company is entitled, so say so and offer a retry rather
// than leaving the page on a spinner that never ends.
export default function CompanySettingsUnavailable() {
  const [{ user }] = useStateValue();
  const fetchCompanySettings = useFetchCompanySettings();

  return (
    <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" onClick={() => fetchCompanySettings(user)}>
            Retry
          </Button>
        }
      >
        We couldn't load your account settings, so this page can't be shown.
      </Alert>
    </Box>
  );
}
